// extracted by mini-css-extract-plugin
export default {"heading":"Yv-z","corrected":"Zv-z","redirectVerbiageContainer":"_v-z","redirectVerbiageText":"aw-z"};